import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { EVENT_2607_PERIOD, isEventLive } from '../config/events'

export const Floating = () => {
    const [isVisible, setIsVisible] = useState(true);

    const floatingStyle = {
        position: 'fixed',
        bottom: '90px',
        right: '20px',
        zIndex: 999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        // gap: '10px'
    };

    const closeButtonStyle = {
        background: 'none',
        border: 'none',
        color: '#e9e9e9',
        cursor: 'pointer',
        fontSize: '20px',
        padding: '5px',
        marginBottom: '-5px'
    };

    const bannerStyle = {
        width: '150px',
        cursor: 'pointer',
        transition: 'transform 0.3s ease',
        animation: 'float 2s ease-in-out infinite'
    };

    useEffect(() => {
        // CSS 애니메이션 추가
        const style = document.createElement('style');
        style.textContent = `
            @keyframes float {
                0% { transform: translateY(0px); }
                50% { transform: translateY(-10px); }
                100% { transform: translateY(0px); }
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    if (!isVisible || !isEventLive(EVENT_2607_PERIOD)) return null;

    return (
        <div style={floatingStyle}>
            <button 
                style={closeButtonStyle}
                onClick={() => setIsVisible(false)}
            >
                ✕
            </button>
            <Link to="/event_2607" target="_self">
                <img 
                    src={process.env.PUBLIC_URL + '/upload/2607/2707-floating.png'} 
                    alt="혹서기 캠페인 바로가기" 
                    style={bannerStyle}
                />
            </Link>
        </div>
    )
}